const theme = {

  // Colors
  pageBackground: '#14151C',
  contentBackground: '#242F3D',
  infoBackground: '#1A202B',
  primaryText: '#F2F2F2',
  supportText: '#9BB9DB',
  placeholderText: '#8097B1',
  errorText: "#DF0000",
  border: '#8CABDA',

  buttonBackground: '#048CB1',
  hover: '#20B4E1',
  disabled: '#18212C',

  // Other Cyans
  cyan: "#05B3E3",
  darkestCyan: "#16719D",

  // Size
  // 1rem = 10px
  fontSizeBase: "1.6rem",
  fontSizeXS: "1.2rem",
  fontSizeS: "1.5rem",
  fontSizeM: "1.8rem",
  fontSizeML: "2.4rem",
  fontSizeL: "2.8rem",
  fontSizeXL: "4rem",
  fontSizeXXL: "6rem",

  fontSize10: "10px",
  fontSize13: "13px",
  fontSize14: "14px",
  fontSize18: "18px",
  fontSize20: "20px",
  fontSize22: "22px",

  // Weight
  fontWeightBold: "600",
  fontWeightMedium: "500",
  fontWeightRegular: "400",
  fontWeightLight: "300",

  // Line height
  lineHeightXL: "50px",
  lineHeightL: "33px",
  lineHeightML: "26px",
  lineHeightBase: "22px",
  lineHeightS: "18px",

  // Letter spacing
  fontSpacingBase: "normal",
  fontSpacingWide: "0.43px",

  // Margins and Padding
  paddingXXS: ".4rem",
  paddingXS: ".8rem",
  paddingS: "1.6rem",
  paddingSM: "2.4rem",
  padding175: "2.8rem",
  paddingM: "3.2rem",
  paddingL: "6.4rem",
  paddingXL: "9.6rem",
  paddingXXL: "12.8rem",
  paddingXXXL: "16rem",

  // Logo
  logoHeight: "24px",
  logoWidth: "110px",

  /* Apple human interface guidelines is minimum 44px by 44px for tappable elements */
  tappable: "44px",

  // Breakpoints
  breakpoints: {
    xxs: 0,
    xs: 320,
    s: 576,
    m: 768,
    l: 992,
    xl: 1200,
    xxl: 1440,
  },
}

export default theme;
